<template>
  <div id="cover">
    <div id="top-mv" class="mv" :style="mv_bgStyle">
      <div class="heart1"><img :src="`${publicPath}img/top/mv_heart01.gif`"></div>
      <h1><img :src="`${publicPath}img/top/mv_title.png`" alt="かぐや様は告らせたい 天才たちとの恋愛頭脳GAME -公式からの無理難題-"></h1>
      <div class="heart2">
        <img class="bg" :src="`${publicPath}img/top/mv_heart02.gif`" alt="">
        <img class="img" :src="`${publicPath}img/top/mv_start.gif`" alt="PRESS START" @click="onClickStart">
      </div>
    </div>
  </div>
</template>

<script>
  // import _$ from 'jquery'

  export default {
    name: 'Story',
    components: {
    },
    props: {
    },
    data(){
      return {
        publicPath: process.env.BASE_URL,
        mv_bgStyle: {
          backgroundImage: 'url(./img/top/top_checkline.png), url(./img/top/top_checkline.png)'
        }
      }
    },
    mounted() {
    },
    destroyed () {
    },
    watch: {

    },
    computed: {

    },
    methods: {
      onClickStart(){
        this.$parent.onChangeState('top')
      }
    }
  }
</script>

<style lang="scss" scoped>
  #cover {
    background: #000;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);

    .mv {
      background-position: top left, bottom left;
      background-repeat: repeat-x, repeat-x;
      background-size: toVW(72) auto;
      height: 100%;
      margin-bottom: toVW(87);
      padding: toVW(72) 0;
      display: flex;
      flex-flow: row wrap;
      align-content: space-around;

      .heart1 {
        width: toVW(641);
        height: toVW(104);
        margin: 0 auto;
      }

      h1 {
        width: toVW(642);
        height: toVW(536);
        margin: 0 auto;
      }

      .heart2 {
        background-repeat: no-repeat;
        background-size: contain;
        width: toVW(675);
        height: toVW(253);
        margin: 0 auto;
        padding-bottom: toVW(10);
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .img {
          width: toVW(439);
          height: toVW(53);
          position: absolute;
          top: toVW(90);
          left: toVW(118);
        }
      }
    }
  }
</style>